<script lang="ts">
    import { service } from "@frontend/services";
    import type { ApiResultOfBannersDTO, ApiResultOfGameServerDTO, AuthenticatedRequestOfEditBannerDTO, AuthenticatedRequestOfEditGameServerDTO, BannersDTO, EditBannerDTO, EditGameServerDTO, GameServerDTO } from "@frontend/walletapi";
    
    export let banner: BannersDTO;
    export let dismiss: () => void;
    
    let result: ApiResultOfBannersDTO | undefined = undefined;
    let editBanner: EditBannerDTO = {
        Id: banner.Id,
        BannerName: banner.BannerName,
        Link: banner.Link,
        Enabled: banner.Enabled,
        BigSelect: banner.BigSelect,
        SmallSelect: banner.SmallSelect
    };

    async function EditBanner() {
        const editBannerRequest: AuthenticatedRequestOfEditBannerDTO = {
            Token: sessionStorage.token,
            Data: editBanner
        };

        try {
            result = await service.walletapi.editBanner(editBannerRequest);
            
            if (result.Success) {
                console.log("Banner updated successfully:", result.Data);
                dismiss();
            } else {
                console.error("Error updating Banner:", result.ErrorMessage);
            }
        } catch (error) {
            console.error("Error updating banner:", error);
        }
    }
</script>

<h2 class="ui centered dividing header">Edit Banner</h2>

{#if result && !result.Success}
    <div class="ui negative message">
        <div class="header">Error</div>
        <p>{result.ErrorMessage ?? "Unknown error when updating server"}</p>
    </div>
{/if}

<form class="ui form" on:submit|preventDefault={EditBanner}>
    <div class="field">
        <label for="">Description</label>
        <input 
            type="text"
            bind:value={editBanner.BannerName}
            placeholder="Enter Description"
            required
        >
    </div>

    <div class="field">
        <label for="">Link</label>
        <input 
            type="text"
            bind:value={editBanner.Link}
            placeholder="Enter username"
            required
        >
    </div>

    <div class="field" style="display: flex; align-items: center; gap: 1em;">
        <label for="enabled" style="margin-bottom: 0; color: {editBanner.Enabled ? 'green' : 'red'}; min-width: 70px;">
            Enabled
        </label>
        <div class="ui toggle checkbox" style="margin-bottom: 0;">
            <input
                type="checkbox"
                bind:checked={editBanner.Enabled}
                id="enabled"
            >
            <label for="enabled" style="display: none;"></label>
        </div>
        <span style="font-weight: bold; color: {editBanner.Enabled ? 'green' : 'red'};">
            {editBanner.Enabled ? 'Activo' : 'Inactivo'}
        </span>
    </div>

    <div class="field">
        <label for="">Big Select</label>
        <input 
            type="text"
            bind:value={editBanner.BigSelect}
            placeholder="Enter server endpoint (IP or URL)"
            required
        >
    </div>
        <div class="field">
        <label for="">Small Select</label>
        <input 
            type="text"
            bind:value={editBanner.SmallSelect}
            placeholder="Enter server endpoint (IP or URL)"
            required
        >
    </div>

    <div class="two fields" style="display: flex">
        <button class="ui negative fluid button" type="button" on:click={dismiss}>Cancel</button>
        <button class="ui positive fluid button" type="submit">Update Banner</button>
    </div>
</form>


